import { forwardRef, useCallback } from 'react';
import { ReactionSelector, ReactionSelectorProps, useChannelStateContext, useMessageContext } from 'stream-chat-react';

export const CustomReactionSelector = forwardRef<HTMLDivElement, ReactionSelectorProps>(
  (props: ReactionSelectorProps, ref) => {
    const {
      message: { own_reactions: ownReactions = [], id: messageId },
    } = useMessageContext();
    const { channel } = useChannelStateContext();
    const handleReaction = useCallback(
      async (reactionType: string) => {
        const hasReactedWithType = (ownReactions ?? []).some((reaction) => reaction.type === reactionType) ?? false;
        if (hasReactedWithType) {
          await channel.deleteReaction(messageId, reactionType);
          return;
        }
        await channel.sendReaction(messageId, { type: reactionType }, { enforce_unique: true });
      },
      [channel, ownReactions, messageId],
    );
    return (
      <div ref={ref}>
        <ReactionSelector {...props} handleReaction={handleReaction} />
      </div>
    );
  },
);
